import { createSelector } from 'reselect';
import { get } from 'lodash/fp';

import { assessLimits, getGames } from '../utils/gameUtils';
import selectionsByGameSelector from './selectionsByGameSelector';

const gamesSelector = createSelector(
  get('challenge.games'),
  get('challenge.playersPerGame'),
  selectionsByGameSelector,
  getGames
);

export default createSelector(gamesSelector, get('challenge.playerQuota'), assessLimits);
